<script setup lang="ts">
import Button from "@/shared/components/Button/Button.vue";
import ColumnLayout from "@/shared/components/ColumnLayout/ColumnLayout.vue";
import ColumnLayoutBox from "@/shared/components/ColumnLayoutBox/ColumnLayoutBox.vue";
import Divider from "@/shared/components/Divider/Divider.vue";
import TextButton from "@/shared/components/TextButton/TextButton.vue";
import Title from "@/shared/components/Title/Title.vue";

defineProps<{
  image: string;
}>();

defineEmits<{
  (e: "request-invite"): void;
  (e: "change-customer-number"): void;
}>();
</script>

<template>
  <ColumnLayout :column-count="2">
    <template #column1>
      <ColumnLayoutBox>
        <div class="request-invite-screen--content">
          <div class="request-invite-screen--section">
            <Title
              size="m"
              :text="$t('registration.user.requestInvite.title')"
            />
            <p class="request-invite-screen--text">
              {{ $t("registration.user.requestInvite.text") }}
            </p>
          </div>
          <Divider />
          <div class="request-invite-screen--section">
            <h2 class="request-invite-screen--subtitle">
              {{ $t("registration.user.requestInvite.howToSignUp.title") }}
            </h2>
            <p class="request-invite-screen--text">
              {{ $t("registration.user.requestInvite.howToSignUp.text") }}
            </p>
          </div>
          <div class="request-invite-screen--actions">
            <Button
              :caption="
                $t('registration.user.requestInvite.action.requestInvite')
              "
              @click="$emit('request-invite')"
            />
            <TextButton
              :caption="
                $t(
                  'registration.user.requestInvite.action.changeCustomerNumber',
                )
              "
              icon="arrowBack"
              @click="$emit('change-customer-number')"
            />
          </div>
        </div>
      </ColumnLayoutBox>
    </template>
    <template #column2>
      <img
        class="request-invite-screen--image"
        :src="image"
        :alt="$t('registration.user.requestInvite.title')"
      />
    </template>
  </ColumnLayout>
</template>

<style scoped>
@import "RequestInviteScreen.css";
</style>
